import { render, staticRenderFns } from "./FeedbackTable.vue?vue&type=template&id=d4dca4f6&"
import script from "./FeedbackTable.vue?vue&type=script&lang=js&"
export * from "./FeedbackTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports